<template>
    <div class="animated fadeIn">
      <div class="row mb-20">
        <div class="col-12">
          <div class="font-bold mb-10">PT Session Analysis</div>
          <div class="box-mini">
            <div class="p-15 pb-0">
              <div class="row">
                <div class="col-sm-8">
                  <table>
                    <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                    <td>
                       <template v-if="getRoleId === '4' || getRoleId === '3' || getRoleId === '20' || getRoleId === '27' || getRoleId === '6' || getRoleId === '17' || paradigm_id === '15101853'">
                        <!-- <a @click="openPage('/leads/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a> -->
                      </template>
  
                    </td>
                    <td>
                        <flat-pickr :config="exportConfig" @on-change="changeDateBooking" v-model="exportDates" name="export_date_start" class="font-13"></flat-pickr>
                    </td>
                  </table>
                </div>
                <div class="col-sm-4 text-right">
                  <div class="row">
                    <div class="col-sm-4 col-form-label text-right">
                      Branch
                    </div>
                    <div class="col-sm-8">
                      <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                          <option :value="null">Please select</option>
                          <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                      </b-form-select>
                    </div>
                  </div>
                </div>
                <div class="col-sm-5 text-right">
                  <!-- <div class="search-header">
                    <div class="custom-search-container">
                      <div class="input-group custom-search">
                        <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                        <span class="icon-magnifier icon-input-custom"></span>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <hr class="mb-0">
            <div class="p-15">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr class="font-weight-bold">
                    <th class="text-center text-nowrap align-middle" rowspan="2">Tier</th>
                    <th class="text-center align-middle" rowspan="2">Active Package</th>
                    <th class="text-center align-middle" rowspan="2">Club</th>
                    <th class="text-center align-middle" colspan="2">Buying Session (Qty+HC)</th>
                    <th class="text-center align-middle" colspan="3">Running Session (Qty+HC)</th>
                    <th class="text-center align-middle" colspan="2">Expired Session (Qty+HC)</th>
                    <th class="text-center align-middle" rowspan="2">Active Package(Ending)</th>
                  </tr>
                  <tr class="font-weight-bold">
                    <th class="text-center">Session Qty</th>
                    <th class="text-center">Head Count (Member)</th>
                    <th class="text-center">Session Qty</th>
                    <th class="text-center">Head Count (Member)</th>
                    <th class="text-center">Head Count (Trainer)</th>
                    <th class="text-center">Session Qty</th>
                    <th class="text-center">Head Count (Member)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="items.length === 0">
                    <td colspan="13" class="text-center">No Data</td>
                  </tr>
                  <template v-else>
                    <template v-for="data in items">
                      <tr :key="data.id" class="align-middle">
                        <td class="text-center">{{data.tier_number}}</td>
                        <td class="text-center">{{formatNumber(data.beginning_qty)}}</td>
                        <td class="text-center">{{data.club}}</td>
                        <td class="text-center">{{formatNumber(data.buying_qty)}}</td>
                        <td class="text-center">{{formatNumber(data.buying_head)}}</td>
                        <td class="text-center">{{formatNumber(data.running_qty)}}</td>
                        <td class="text-center">{{formatNumber(data.running_head)}}</td>
                        <td class="text-center">{{formatNumber(data.running_trainer)}}</td>
                        <td class="text-center">{{formatNumber(data.expired_qty)}}</td>
                        <td class="text-center">{{formatNumber(data.expired_head)}}</td>
                        <td class="text-center">{{formatNumber(data.ending_qty)}}</td>
                      </tr>
                    </template>
                    <!-- total -->
                    <tr class="font-weight-bold">
                      <td class="text-right bg-custom"><b>Total</b></td>
                      <td class="text-center bg-custom">{{formatNumber(calculateTotal('beginning_qty'))}}</td>
                      <td class="text-center bg-custom"></td>
                      <td class="text-center bg-custom">{{formatNumber(calculateTotal('buying_qty'))}}</td>
                      <td class="text-center bg-custom">{{formatNumber(calculateTotal('buying_head'))}}</td>
                      <td class="text-center bg-custom">{{formatNumber(calculateTotal('running_qty'))}}</td>
                      <td class="text-center bg-custom">{{formatNumber(calculateTotal('running_head'))}}</td>
                      <td class="text-center bg-custom">{{formatNumber(calculateTotal('running_trainer'))}}</td>
                      <td class="text-center bg-custom">{{formatNumber(calculateTotal('expired_qty'))}}</td>
                      <td class="text-center bg-custom">{{formatNumber(calculateTotal('expired_head'))}}</td>
                      <td class="text-center bg-custom">{{formatNumber(calculateTotal('ending_qty'))}}</td>
                    </tr>
                  </template>

                </tbody>
              </table>
              <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                  :total-pages="totalPage"
                  @page-changed="pageOneChanged"
                  prev-text="Prev" next-text="Next"/>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loadingActive == true" class="loading-container">
        <div class="wrap-screen w-100 h-100">
          <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
          <div class="title-loading color-white">Loading...</div>
        </div>
      </div>
    </div>
  </template>

  <style>
    .bg-custom {
      background-color: #fff0c4;
    }
  </style>
  
  <script>
  import { Callout } from '@coreui/vue'
  import axios from 'axios'
  import { Auth } from '@/api'
  import moment from 'moment'
  import Pagination from '@/views/component/pagination'
  
  export default {
    name: 'leads',
    components: {
      'app-pagination': Pagination
    },
    props: {
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: true
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        loadingActive: false,
        fields: [
          {
            key: 'trx_id',
            label: 'TRX ID',
            sortable: true
          },
          {
            key: 'trx_date',
            label: 'Date',
            sortable: true
          },
          {
            key: 'gross_amount',
            label: 'Gross Amount',
            formatter: (value, key, item) => {
              return 'Rp. ' + parseFloat(item.gross_amount).toLocaleString('id-ID', {maximumFractionDigits:2})
            },
            sortable: true
          },
          {
            key: 'branch.codename',
            label: 'Club',
            sortable: true
          },
          {
            key: 'transaction_type.name',
            label: 'Transaction Type',
            sortable: true
          },
          {
            key: 'member',
            label: 'Member',
            sortable: false
          },
          {
            key: 'gross_amount',
            label: 'Gross Amount',
            sortable: true
          },
          {
            key: 'payment_type_1.name',
            label: 'Payment Type',
            sortable: true
          },
          {
            key: 'payment_card_1.name',
            label: 'Payment Card',
            sortable: true
          },
          {
            key: 'charges',
            label: 'Charges',
            formatter: (value, key, item) => {
              return 'Rp. ' + parseFloat(item.charges).toLocaleString('id-ID', {maximumFractionDigits:2})
            },
            sortable: true
          }
        ],
        branch_id: null,
        dataBranch: [],
        dateWeek: '',
        items: [],
        get_data_transaction_leads: [],
        sortType: '',
        sortBy: '',
        searchData: '',
        currentPage: 1,
        paginationLimit: 5000,
        totalPage: 0,
        getRoleId: Auth.Session.get().paradigm_role,
        exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+((moment().year()+1) + moment().endOf('month').format('-MM-DD')),
        start_date: null,
        end_date: null,
        paradigm_id:Auth.Session.get().paradigm_id,
        // exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
        exportConfig: {
          mode: "range",
          dateFormat: "Y-m-d",
          altInput: true,
          altFormat: "d/m/y",
          defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), ((moment().year()+1) + moment().endOf('month').format('-MM-DD'))]
        }
      }
    },
    methods: {
      calculateTotal(property) {
        let total = 0
        this.items.forEach(item => {
          total += parseInt(item[property])
        })
        return total
      },
        exportReport() {
            let dates = this.exportDates.split(' to ')
            let url = 'crm/v1/export/finance/pt_session_analysis?start_date='+dates[0]+'&end_date='+dates[1]

            if (this.branch_id != null) {
            url += '&branch_id=' + this.branch_id
            }

            axios({
            method: 'get',
            url: url,
            responseType: 'arraybuffer'
            }).then(response => {
            let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'PT Session Analysis '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
            link.click()
            }).catch(error => {
            console.log('error', error)
            })
        },
      changeBranch(event) {
        this.loadingActive = true;
        // console.log(event)
        this.fetchData()
      },
      changeDateBooking(selectedDates, dateStr, instance) {
        if(selectedDates.length === 2){
            if(typeof selectedDates[0] === typeof selectedDates[1]){
                this.exportDates = dateStr + ' to ' + dateStr
            }else{
                this.exportDates = dateStr
            }
            if(this.exportDates.includes(" to ") === true) {
              this.loadingActive = true;
              let dates = this.exportDates.split(' to ')
              let start_date = dates[0]
              let end_date = dates[1] == undefined ? '' : dates[1]
              this.start_date = start_date
              this.end_date = end_date
              localStorage.setItem('leads_date_range', `${start_date} to ${end_date}`)
              this.fetchData()
            }
        }
      },
      pageOneChanged (pageNum) {
        let currentUrl = window.location.href
        let url = new URL(currentUrl)
        url.searchParams.set("page", pageNum)
        let newUrl = url.href
        window.history.pushState("Page","Paradigm Fitness Indonesia","?page="+pageNum)
        this.currentPage = pageNum
        this.fetchData()
      },
      sortingChanged (event) {
        this.loadingActive = true;
        this.sortBy = event.sortBy
        if (event.sortDesc === false) {
          this.sortType = 'asc'
        } else {
          this.sortType = 'desc'
        }
        this.fetchData()
      },
      enterClicked (searchEvent) {
        this.fetchData()
      },
      deleteData(event) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You can\'t revert your action',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes Delete it!',
          cancelButtonText: 'No, Keep it!',
          showCloseButton: true,
          showLoaderOnConfirm: false
        }).then((result) => {
          if(result.value) {
            this.$swal('Deleted', 'You successfully deleted this file', 'success')
            axios.delete('crm/v1/leads/' + event).then(response => {
              // this.$router.go()
              this.fetchData()
            }).catch(error => {
              console.log('error', error)
            })
          } else {
            this.$swal('Cancelled', 'Your file is still intact', 'info')
          }
        })
      },
      getRowCount (items) {
        return items.length
      },
      getBadge (status) {
        return status === 'Active' ? 'success'
          : status === 'Inactive' ? 'danger'
            : status === 'active' ? 'success'
              : status === 'inactive' ? 'danger' : 'primary'
      },
      statusMembership (status) {
        console.log('STATUS: ', status)
        return (status === 'Membership') ? 'success'
            : (status === 'On Progress') ? 'warning' : (status === 'miss_guest') ? 'warning' : 'danger'
      },
      statusActivity (status) {
        return (status === 'Membership') ? 'success'
            : (status === 'On Progress') ? 'warning' : 'danger'
      },
      openPage (event) {
        this.$router.push(event)
      },
      formatNumber(event) {
        var data = parseInt(event)
        return data.toLocaleString('id-ID', {maximumFractionDigits:0})
      },
      todayNumber () {
        return moment().isoWeekday()
      },
      cutTime (value) {
        return (value).slice(0, -3)
      },
      getNumberDay (value) {
        return moment(new Date(value)).isoWeekday()
      },
      parseDateTime1 (value) {
        moment.locale('en')
        return moment(new Date(value)).format('DD')
      },
      parseDateTime2 (value) {
        moment.locale('en')
        return moment(new Date(value)).format('dddd')
      },
      parseDateTime3 (value) {
        var curr = new Date
        var first = curr.getDate() - curr.getDay()
        var monthName = new Date(curr.getTime())
        moment.locale('en')
        return moment(new Date(monthName)).format('MMMM YYYY')
      },
      parseImg (value) {
        return Auth.apiUrl + 'crm/v1/img/banner/' + value
      },
      getLeadsTransaction(id) {
         axios.get("crm/v1/leads/get_transaction?leads_id=" + id)
          .then(response => {
            let res_data = response.data.data.rows
            console.warn('VANGKE: ',  res_data.length +' - ' + id)
            console.warn(res_data.length)
            if (res_data.length > 0) {
              return false
            } else {
              return true
            }
          })
          .catch(error => {
            console.log("error", error);
             return false
          });
      },
      fetchData() {
        let dates = this.exportDates.split(' to ')
        this.getRoleId = Auth.Session.get().paradigm_role
        let end_date = dates[1] == undefined ? '' : dates[1]

        let branch = ''

        if (this.branch_id == null) {
          branch = ''
        } else {
          branch = this.branch_id
        }
        
        axios.get('crm/v1/finance/report/pt_session_analysis?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +'&start_date='+dates[0]
          +'&end_date='+end_date + '&branch_id=' + branch).then(response => {
            this.items = response.data.data.rows
            this.totalPage = response.data.meta.pageCount
            this.loadingActive = false;
          }).catch(error => {
            this.loadingActive = false;
            console.log('error', error)
          })
  
        // branch
        axios.get('fitness/v1/branch/').then(response => {
          this.dataBranch = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    created () {
      let urlParams = new URLSearchParams(window.location.search)
      let pageParams = urlParams.get('page')
      this.currentPage = (pageParams != null) ? parseInt(pageParams) : 1
      const get_current_date = localStorage.getItem('leads_date_range')
      if (get_current_date) {
        this.exportDates = get_current_date
      }
  
      this.fetchData()
    },
    destroyed() {
      if (this.$router.currentRoute.path != '/leads/detail') {
        localStorage.removeItem('leads_date_range')
      }
    }
  }
  </script>
  